module.exports = __webpack_public_path__ + "static/media/user.7f184d12.svg";